module.exports = __webpack_public_path__ + "static/media/ScanProductCK.a5f87f99.png";